import styled from "@emotion/styled";
import {Box} from "@mui/material";
import {media} from "assets/css/media";

export const ModalBox = styled(Box)`
	background: #fff;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: calc(100% - 40px);
	max-width: 600px;
	min-width: 320px;

	border-radius: 8px;
	overflow: hidden;

	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 20px;
	gap: 24px;
	box-sizing: border-box;
	outline: none;

	&.share_box {
		padding: 20px 0px;

		@media (min-width: ${media.mobile}) {
			padding-top: 40px;
		}
	}
`;

export const ModalContent = styled(Box)`
	max-height: 85vh;
	overflow: auto;
	color: #001436;
	width: 100%;

	&.share_content {
		padding: 0 20px;
	}

	// FIX for iOS
	@supports (-webkit-touch-callout: none) {
		max-height: 75vh;
	}
`;

export const ModalBody = styled(Box)`
	color: #001436;
`;

export const ModalHeader = styled.div`
	margin-top: 10px;
	padding: 16px 0;
	display: flex;
	justify-content: center;
`;

export const ModalTitle = styled.h3`
	font-family: var(--fontFamilySecond);
	text-align: center;
	margin: 20px 0;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 100%;
	letter-spacing: 3.2px;
	text-transform: uppercase;
`;

export const ModalSubTitle = styled.h4`
	font-weight: 700;
	font-size: 20px;
	margin-bottom: 16px;
	text-align: center;
`;

export const ModalText = styled.p`
	font-family: var(--fontFamilySecond);
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 130%;
	text-align: center;
	margin: 0px 0 20px;
`;

export const ModalTextWOMargin = styled(ModalText)`
	margin-bottom: 0;
`;

export const ModalFooter = styled(Box)`
	padding: 15px 0 0;
	box-sizing: border-box;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 20px;

	button,
	a {
		max-width: unset;
		width: 100%;
		flex: 1 1 50%;
	}

	@media screen and (max-width: 760px) {
		flex-direction: column;
	}
`;
export const CloseBtn = styled(Box)`
	width: 32px;
	height: 32px;
	position: absolute;
	top: 20px;
	right: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	padding: 5px;
`;
